export function validUrlOrNone(urlString: string): URL|null {
    try {
        return  new URL(urlString)
    } catch (err) {
        return null;
    }
}